import styled from 'styled-components';

export const StyledPropertyDetails = styled.div<{ limitWidth?: boolean }>`
  ${({ theme }) => theme.breakpoints.up('md')} {
    &.property-details-wrapper {
      padding: ${({ theme }) => theme.spacing(0, 3)};
    }
  }

  &.property-details-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    ${({ limitWidth, theme }) => limitWidth && `max-width: ${theme.breakpoints.values.lg + 200}px;`}
    margin: auto;

    .property-details-zillow-graph {
      max-width: 700px;
    }

    .sub-action-text-wrapper {
      float: right;
      text-align: center;
      width: 100%;
      max-width: 300px; // Max width of MuiButton
    }

    .property-progress-bar {
      position: relative;

      &:not(.label-in-bar) {
        .linear-progress-bar-label {
          position: absolute;
          top: -${({ theme }) => theme.spacing(2.5)};
          right: ${({ theme }) => theme.spacing(2.5)};
        }
      }
    }

    .footer-wrapper {
      .footer-columns {
        padding: ${({ theme }) => theme.spacing(4, 4, 2)};
      }

      .disclaimer {
        padding: ${({ theme }) => theme.spacing(2, 4)};
      }
    }

    .about-the-offering {
      padding: ${({ theme }) => theme.spacing(0, 0, 3, 4)};
    }

    &.mobile {
      min-width: 350px;

      .about-the-offering {
        padding: ${({ theme }) => theme.spacing(0, 0, 0, 2)};
      }

      &.no-scrolling {
        overflow: hidden;
      }

      &.market-offering {
        .property-details-sticky-footer {
          .property-details-action-container {
            justify-content: center;
          }
        }
      }

      .property-details-header-wrapper {
        .property-details-header-availability {
          padding-bottom: ${({ theme }) => theme.spacing(2)};
        }
      }

      .property-details-sticky-footer {
        position: sticky;
        z-index: 5;
        bottom: 0;
        width: 100%;
        padding-top: 0;
        background-color: ${({ theme }) => theme.palette.neutrals.white};

        .property-details-action-container {
          display: flex;
          flex-basis: 100px;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: center;
          padding: ${({ theme }) => theme.spacing(2.5)};

          .property-details-header-action {
            width: 233px;
            margin-right: 0;

            .styled-button {
              padding: ${({ theme }) => theme.spacing(2)};
            }

            .sub-action-text-wrapper {
              .sub-action-text {
                color: ${({ theme }) => theme.palette.darkened.midnight};
              }
            }
          }
        }
      }
    }
  }
`;
